setTimeout(function(){
  $(document).ready(function () {
    const initiate_slick = $('.slider-mobile-gutter .grid.product-grid.home_initiate_slick');
    initiate_slick.slick({
      slidesToShow: 4,
      slidesToScroll: 1,
      arrows: true,
      dots: false,
      autoplay: false,
      autoplaySpeed: 3000,
      infinite: true,
      responsive: [
        {
          breakpoint: 1000,
          settings: {
            autoplaySpeed: 2000,
            slidesToShow: 3,
            slidesToScroll: 1
          }
        },
        {
          breakpoint: 700,
          settings: {
            autoplaySpeed: 2000,
            slidesToShow: 2,
            slidesToScroll: 1
          }
        }
      ]
    });
  });
}, 1000)
